import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Inbox, FolderInput } from "lucide-react";
import { toast } from "sonner";
import api, { apiError } from "../lib/api";
import { Button } from "./ui/button";
import { fmtDate } from "./ui-kit";

export const ReferralInbox = ({ context = "intake" }) => {
  const [rows, setRows] = useState(null);
  const [busy, setBusy] = useState("");
  const [staff, setStaff] = useState([]);
  const [picks, setPicks] = useState({});
  const load = () => api.get("/referrals/inbox/queue").then((r) => setRows(r.data)).catch(() => setRows([]));
  useEffect(() => { load(); api.get("/staff-directory").then((r) => setStaff(r.data)).catch(() => {}); }, []);
  const pick = (id, k, v) => setPicks((p) => ({ ...p, [id]: { ...(p[id] || {}), [k]: v } }));

  const file = async (r) => {
    setBusy(r.id);
    try {
      const sel = picks[r.id] || {};
      const { data } = await api.post(`/referrals/${r.id}/file`, { worker_user_id: sel.worker || null, intake_date: sel.intake_date || null });
      toast.success(`${data.created_client ? "New client created and referral filed" : "Referral filed to client chart"}${data.assigned_worker ? ` · assigned to ${data.assigned_worker.name}` : ""}${data.intake_date ? ` · intake ${data.intake_date}` : ""}`);
      window.dispatchEvent(new Event("referral-inbox-changed"));
      load();
    } catch (e) { toast.error(apiError(e)); }
    setBusy("");
  };

  if (!rows || rows.length === 0) return null;
  return (
    <div className="mb-5 rounded-2xl border border-primary/20 bg-primary/5 p-4" data-testid={`referral-inbox-${context}`}>
      <div className="mb-2 flex items-center gap-2 text-sm font-bold"><Inbox className="h-4 w-4 text-primary" /> Referrals received — not yet in a chart <span className="rounded-full bg-[#91661E] px-2 py-0.5 text-[11px] font-bold text-white">{rows.length}</span></div>
      <ul className="divide-y divide-border">
        {rows.map((r) => (
          <li key={r.id} className="flex flex-wrap items-center justify-between gap-2 py-2 text-sm" data-testid={`inbox-row-${r.id}`}>
            <div className="min-w-0">
              <p className="font-semibold">{r.client_name} <span className="font-normal text-muted-foreground">· DOB {r.dob || "—"}</span></p>
              <p className="text-xs text-muted-foreground">From {r.provider?.full_name || "provider"} · {fmtDate(r.relevant_date || r.created_at)} · {r.ref}</p>
            </div>
            <div className="flex flex-wrap items-center gap-2">
              <select className="h-8 rounded-lg border border-border bg-white px-2 text-xs" value={picks[r.id]?.worker || ""} onChange={(e) => pick(r.id, "worker", e.target.value)} data-testid={`inbox-worker-${r.id}`}>
                <option value="">Assign worker (optional)</option>
                {staff.map((s) => <option key={s.user_id} value={s.user_id}>{s.name} — {s.role_label}</option>)}
              </select>
              <input type="date" className="h-8 rounded-lg border border-border bg-white px-2 text-xs" value={picks[r.id]?.intake_date || ""} onChange={(e) => pick(r.id, "intake_date", e.target.value)} title="Intake date (optional)" data-testid={`inbox-intake-${r.id}`} />
              <Button asChild size="sm" variant="outline"><Link to={`/app/referrals/${r.id}`} data-testid={`inbox-open-${r.id}`}>Review</Link></Button>
              <Button size="sm" disabled={busy === r.id} onClick={() => file(r)} data-testid={`inbox-file-${r.id}`}><FolderInput className="mr-1 h-4 w-4" /> {r.suggested_client_uuid ? "File to chart" : "File & create client"}</Button>
            </div>
          </li>
        ))}
      </ul>
    </div>
  );
};
